import React, { useContext, useEffect, useState } from 'react'
import Button from '../components/button'
import Top from '../components/top'
import Table from '../components/table'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../contexts/AuthProvider'
import { DetailsContext } from '../contexts/DetailsContext'

const Verified = (props) => {
    const [showModal, setShowModal] = useState(false);
    const {
      user,
      setUser,
      isLogged,
      setIsLogged,
      login,
      logout
    } = useContext(AuthContext)

    const { verifications } = useContext(DetailsContext)
    
    const navigate = useNavigate()
    useEffect(() => {
      if (!isLogged) {
        navigate('/')
      }
    }, [isLogged])

    const inputs = [
        {
          name: "status",
          icon: 'fa-solid fa-user',
          type: 'select',
          vals: [
            {name: 'Pending', option:'Pending'},
            {name: 'Completed', option:'Completed'},
          ],
        }
      ]

    props.setNavShow(true)
    function formatNumber(number) {
      return number.toLocaleString('en-US', { 
          minimumFractionDigits: 2, 
          maximumFractionDigits: 2 
      });
  }
    const userColumns = ['Account ID', 'Verification ID', 'email', 'DOB', 'ID Number', 'Name', 'Phone']
    function addUsers(){
        window.location.replace('/edit')
    }
    const link = 'https://xgramm.com/xgramm_backend/admin/verifications.php'
  return (
    <div  style={{position: 'relative'}} className='w3-col l9 w3-right m9 s12 main'>
        <Top showModal={showModal} setShowModal={setShowModal} isAdd={false} value='Add New Request' name='Verifications'/>
        <div className="w3-container">
        <Table tableName='verification' link={link} inputs={inputs} showModal={showModal} setShowModal={setShowModal} name='Verification Requests' columns={userColumns} data={verifications ? verifications : []} summary={false} edit={true} />
        </div>
    </div>
  )
}

export default Verified